<template>
  <div class="fail">
    <div>
      <div>
        <div class="errorLogo">
          <img src="/assets/wrong_id_error.png" />
        </div>
        <div class="bigText blue">{{ $t("wrong") }}</div>
      </div>
      <div class="text">
        {{ $t("wrong_details") }}
      </div>
      <div class="steps">
        <div>
          <div class="content">
            <div class="white">{{ $t("step1") }}</div>
            <div class="space"></div>
            <div>{{ $t("step1_details") }}</div>
          </div>
          <span><img src="/assets/step1.png" /></span>
        </div>
        <div class="mid"><div></div></div>
        <div>
          <div class="content">
            <div class="white">{{ $t("step2") }}</div>
            <div class="space"></div>
            <div>{{ $t("step2_details") }}</div>
          </div>
          <div><img src="/assets/step2.png" /></div>
        </div>
      </div>
    </div>
    <div class="warn blue">
      <div class="">
        <span class="blue">{{ $t("gentle") }}</span
        ><span class="line"></span><span v-html="reminderMessage"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    reminderMessage() {
      const link =
        '<span class="white">https://verify.pgslotxaskmebet.com</span>';
      return this.$t("reminder", { link });
    },
  },
};
</script>
